(function () {
  "use strict";

  function initDRFCustomKeychain() {
    const builder = document.getElementById("drf-custom-builder");

    if (!builder) return;
    if (builder.dataset.drfInitialized === "true") return;

    builder.dataset.drfInitialized = "true";

    /* ==========================================================
       SHOPIFY VARIANTS
    ========================================================== */

    const variants = {
      "text-text": {
        id: "54802791432538",
        price: 13.50
      },
      "text-photo": {
        id: "54802791465306",
        price: 15.00
      },
      "text-none": {
        id: "54802791498074",
        price: 10.00
      },
      "photo-text": {
        id: "54802791530842",
        price: 15.00
      },
      "photo-photo": {
        id: "54802791563610",
        price: 16.50
      },
      "photo-none": {
        id: "54802791596378",
        price: 11.50
      },
      "none-text": {
        id: "54802791629146",
        price: 10.00
      },
      "none-photo": {
        id: "54802791661914",
        price: 11.50
      },
      "none-none": {
        id: "54802791694682",
        price: 6.50
      }
    };
        /* ==========================================================
       LIVE SHOPIFY VARIANT PRICES
       ========================================================== */

    async function loadLiveVariantPrices() {
      try {
        const path = window.location.pathname;
        const match = path.match(/\/products\/([^\/]+)/);

        if (!match) return;

        const productHandle = match[1];

        const response = await fetch(
          "/products/" + productHandle + ".js"
        );

        if (!response.ok) return;

        const productData = await response.json();

        if (
          !productData ||
          !Array.isArray(productData.variants)
        ) {
          return;
        }

        productData.variants.forEach(function (shopifyVariant) {
          const variant = Object.values(variants).find(
            function (item) {
              return String(item.id) === String(shopifyVariant.id);
            }
          );

         if (variant) {
  variant.price =
    Number(shopifyVariant.price) / 100;

  variant.available =
    shopifyVariant.available;
}
        });

        updateCustomPurchaseUI();
        updateNativePrice();

      } catch (error) {
        console.warn(
          "DRF Custom Keychain: Could not load live Shopify prices.",
          error
        );
      }
    }

    /* ==========================================================
       STATE
    ========================================================== */

    let front = "text";
    let back = "text";

    let frontFont = "Classic";
    let backFont = "Classic";

    let frontDirection = "Horizontal";
    let backDirection = "Horizontal";

    /*
      Prevent an old asynchronous photo conversion from
      appearing after the customer has switched to Text.
    */
    const photoRenderToken = {
      front: 0,
      back: 0
    };

    /* ==========================================================
       FORM
    ========================================================== */

    const form =
      builder.closest('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!form) {
      console.warn(
        "DRF Custom Keychain: Shopify product form not found."
      );
    }

    const variantInput = form
      ? (
          form.querySelector("input.product-variant-id") ||
          form.querySelector('input[name="id"]')
        )
      : (
          document.querySelector("input.product-variant-id") ||
          document.querySelector('input[name="id"]')
        );

    const errorElement =
      builder.querySelector("#drf-custom-error");

    const frontPreview =
      builder.querySelector("#drf-front-preview");

    const backPreview =
      builder.querySelector("#drf-back-preview");

    if (form && form.id) {
  builder
    .querySelectorAll("input, select, textarea")
    .forEach(function (input) {
      if (input.name) {
        input.setAttribute("form", form.id);
      }
    });

  /* ==========================================================
     FORCE CUSTOM KEYCHAIN PROPERTIES INTO SHOPIFY FORM DATA
     ========================================================== */

  form.addEventListener("formdata", function (event) {
    const data = event.formData;

    const frontText = getTextInput("front");
    const backText = getTextInput("back");
    const frontPhoto = getPhotoInput("front");
    const backPhoto = getPhotoInput("back");

    const frontFont = builder.querySelector("#drf-front-font");
    const backFont = builder.querySelector("#drf-back-font");

    const frontDirection =
      builder.querySelector("#drf-front-direction");

    const backDirection =
      builder.querySelector("#drf-back-direction");

    /* Remove any existing versions first */
    data.delete("properties[Front Text]");
    data.delete("properties[Front Font]");
    data.delete("properties[Front Direction]");
    data.delete("properties[Front Photo]");

    data.delete("properties[Back Text]");
    data.delete("properties[Back Font]");
    data.delete("properties[Back Direction]");
    data.delete("properties[Back Photo]");

    /* FRONT */
    if (front === "text") {
      if (frontText && frontText.value.trim()) {
        data.append(
          "properties[Front Text]",
          frontText.value.trim()
        );
      }

      if (frontFont && frontFont.value) {
        data.append(
          "properties[Front Font]",
          frontFont.value
        );
      }

      if (frontDirection && frontDirection.value) {
        data.append(
          "properties[Front Direction]",
          frontDirection.value
        );
      }
    }

    if (
      front === "photo" &&
      frontPhoto &&
      frontPhoto.files &&
      frontPhoto.files.length
    ) {
      data.append(
        "properties[Front Photo]",
        frontPhoto.files[0]
      );
    }

    /* BACK */
    if (back === "text") {
      if (backText && backText.value.trim()) {
        data.append(
          "properties[Back Text]",
          backText.value.trim()
        );
      }

      if (backFont && backFont.value) {
        data.append(
          "properties[Back Font]",
          backFont.value
        );
      }

      if (backDirection && backDirection.value) {
        data.append(
          "properties[Back Direction]",
          backDirection.value
        );
      }
    }

    if (
      back === "photo" &&
      backPhoto &&
      backPhoto.files &&
      backPhoto.files.length
    ) {
      data.append(
        "properties[Back Photo]",
        backPhoto.files[0]
      );
    }
  });
}

    /* ==========================================================
       HELPERS
    ========================================================== */

    function currentKey() {
      return front + "-" + back;
    }

    function capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }

    function setError(message) {
      if (!errorElement) return;

      if (message) {
        errorElement.textContent = message;
        errorElement.style.display = "block";
      } else {
        errorElement.textContent = "";
        errorElement.style.display = "none";
      }
    }

    function getTextInput(side) {
      return builder.querySelector(
        side === "front"
          ? "#drf-front-text"
          : "#drf-back-text"
      );
    }

    function getPhotoInput(side) {
      return builder.querySelector(
        side === "front"
          ? "#drf-front-photo"
          : "#drf-back-photo"
      );
    }

    function getPreview(side) {
      return side === "front"
        ? frontPreview
        : backPreview;
    }

    function getFontClass(font) {
      if (font === "Elegant Script") {
        return "font-script";
      }

      if (font === "Modern") {
        return "font-modern";
      }

      if (font === "Bold") {
        return "font-bold";
      }

      if (font === "Luxury") {
        return "font-luxury";
      }

      return "font-classic";
    }

    /* ==========================================================
       PRICE
    ========================================================== */

    function updateNativePrice() {
      const selected = variants[currentKey()];

      if (!selected) return;

      const productArea =
        builder.closest(".product") ||
        document.querySelector(".product");

      if (!productArea) return;

      const formatted =
        "€" + selected.price.toFixed(2);

      productArea
        .querySelectorAll(
          ".price .price-item--regular, " +
          ".price .price-item--sale, " +
          ".product__price .price-item--regular, " +
          ".product__price .price-item--sale"
        )
        .forEach(function (element) {
          element.textContent = formatted;
        });
    }

    /* ==========================================================
       DAWN VARIANT OPTIONS
    ========================================================== */

    function updateNativeVariantOptions() {
      const productArea =
        builder.closest(".product") ||
        document.querySelector(".product");

      if (!productArea) return;

      const selectors =
        productArea.querySelectorAll(
          "variant-selects, variant-radios"
        );

      if (!selectors.length) return;

      function setOption(optionName, value) {
        selectors.forEach(function (selector) {
          const select =
            selector.querySelector(
              'select[name="options[' +
              optionName +
              ']"]'
            );

          if (select) {
            if (select.value !== value) {
              select.value = value;

              select.dispatchEvent(
                new Event("change", {
                  bubbles: true
                })
              );
            }

            return;
          }

          const radio =
            selector.querySelector(
              'input[name="options[' +
              optionName +
              ']"][value="' +
              value +
              '"]'
            );

          if (radio && !radio.checked) {
            radio.checked = true;

            radio.dispatchEvent(
              new Event("change", {
                bubbles: true
              })
            );
          }
        });
      }

      setOption(
        "Front",
        capitalize(front)
      );

      setOption(
        "Back",
        capitalize(back)
      );
    }

    /* ==========================================================
       SHOPIFY VARIANT
    ========================================================== */

    function updateShopifyVariant() {
      const selected =
        variants[currentKey()];

      if (!selected) return;

      if (variantInput) {
        variantInput.value =
          selected.id;

        variantInput.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );
      }

     updateNativeVariantOptions();
updateNativePrice();
updateCustomPurchaseUI();
setError("");
    }

    /* ==========================================================
       RESET TEXT UI
    ========================================================== */

    function resetTextUI(side) {
      const textInput =
        getTextInput(side);

      const photoInput =
        getPhotoInput(side);

      /*
        Completely clear the previous photo.
      */

      if (photoInput) {
        photoInput.value = "";
      }

      /*
        Completely clear previous text.
      */

      if (textInput) {
        textInput.value = "";
      }

      const counter =
        textInput
          ?.closest(".drf-text-wrap")
          ?.querySelector(".drf-counter");

      if (counter) {
        counter.textContent = "0/20";
      }

      /*
        Fresh default font and direction.
      */

      if (side === "front") {
        frontFont = "Classic";
        frontDirection = "Horizontal";
      } else {
        backFont = "Classic";
        backDirection = "Horizontal";
      }

      const hiddenFont =
        builder.querySelector(
          side === "front"
            ? "#drf-front-font"
            : "#drf-back-font"
        );

      if (hiddenFont) {
        hiddenFont.value = "Classic";
      }

      const hiddenDirection =
        builder.querySelector(
          side === "front"
            ? "#drf-front-direction"
            : "#drf-back-direction"
        );

      if (hiddenDirection) {
        hiddenDirection.value =
          "Horizontal";
      }

      /*
        Reset font selector to:
        Aa — Classic
      */

      const trigger =
        builder.querySelector(
          '[data-font-trigger="' +
          side +
          '"]'
        );

      if (trigger) {
        const previewText =
          trigger.querySelector(
            ".drf-font-preview-text"
          );

        const name =
          trigger.querySelector(
            ".drf-selected-font-name"
          );

        if (previewText) {
          previewText.className =
            "drf-font-preview-text font-classic";

          /*
            IMPORTANT:
            Do not put the customer's text here.
            The closed selector only shows Aa.
          */

          previewText.textContent =
            "Aa";
        }

        if (name) {
          name.textContent =
            "Classic";
        }
      }

      const menu =
        builder.querySelector(
          '[data-font-menu="' +
          side +
          '"]'
        );

      if (menu) {
        menu
          .querySelectorAll(
            ".drf-font-option"
          )
          .forEach(function (item) {
            item.classList.toggle(
              "active",
              item.dataset.font === "Classic"
            );
          });

        menu.classList.remove("open");
      }

      const directionRow =
        builder.querySelector(
          '[data-direction-side="' +
          side +
          '"]'
        );

      if (directionRow) {
        directionRow
          .querySelectorAll(
            ".drf-direction"
          )
          .forEach(function (button) {
            button.classList.toggle(
              "active",
              button.dataset.direction ===
              "horizontal"
            );
          });
      }
    }

    /* ==========================================================
       TEXT PREVIEW
    ========================================================== */

    function updateTextPreview(side) {
      const preview =
        getPreview(side);

      if (!preview) return;

      const input =
        getTextInput(side);

      const text =
        input &&
        input.value.trim()
          ? input.value.trim()
          : "Your text";

      const font =
        side === "front"
          ? frontFont
          : backFont;

      const direction =
        side === "front"
          ? frontDirection
          : backDirection;

      /*
        Remove old photo completely.
      */

      preview.innerHTML = "";

      const textSpan =
        document.createElement("span");

      textSpan.textContent =
        text;

      textSpan.className =
        getFontClass(font);

      preview.appendChild(
        textSpan
      );

      preview.classList.toggle(
        "drf-rotated",
        direction === "Rotated"
      );
    }

    /* ==========================================================
       PHOTO ENGRAVING
    ========================================================== */
function createEngravingImage(
  file,
  preview
) {
  const reader = new FileReader();

  reader.onload = function (event) {
    const image = new Image();

    image.onload = function () {
      const canvas =
        document.createElement("canvas");

      const targetRatio = 0.72;

      const sourceRatio =
        image.width / image.height;

      let cropWidth = image.width;
      let cropHeight = image.height;
      let cropX = 0;
      let cropY = 0;

      if (sourceRatio > targetRatio) {
        cropWidth =
          image.height * targetRatio;

        cropX =
          (image.width - cropWidth) / 2;

      } else {
        cropHeight =
          image.width / targetRatio;

        cropY =
          (image.height - cropHeight) / 2;
      }

      const outputWidth = 1000;

      const outputHeight =
        Math.round(
          outputWidth / targetRatio
        );

      canvas.width =
        outputWidth;

      canvas.height =
        outputHeight;

      const ctx =
        canvas.getContext(
          "2d",
          {
            willReadFrequently: true
          }
        );

      /*
        Draw the exact same photo we already
        know looks good.
      */
      ctx.drawImage(
        image,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        outputWidth,
        outputHeight
      );

      const imageData =
        ctx.getImageData(
          0,
          0,
          outputWidth,
          outputHeight
        );

      const pixels =
        imageData.data;

      /*
        ========================================================
        REMOVE ONLY THE OUTER WHITE BACKGROUND
        ========================================================

        We do NOT remove every white pixel.

        We start from the outside edges and remove
        only bright, neutral pixels that are connected
        to the outside background.

        This protects white engraving details inside
        the dog's artwork.
      */

      const totalPixels =
        outputWidth * outputHeight;

      const background =
        new Uint8Array(totalPixels);

      const queueX =
        new Int32Array(totalPixels);

      const queueY =
        new Int32Array(totalPixels);

      let queueStart = 0;
      let queueEnd = 0;

      /*
        A pixel is considered background-like when
        it is very bright and close to neutral white.
      */

      function isBackgroundPixel(index) {
        const p = index * 4;

        const r = pixels[p];
        const g = pixels[p + 1];
        const b = pixels[p + 2];

        const minimum =
          Math.min(r, g, b);

        const maximum =
          Math.max(r, g, b);

        return (
          minimum >= 235 &&
          maximum - minimum <= 18
        );
      }

      function addPixel(x, y) {
        if (
          x < 0 ||
          x >= outputWidth ||
          y < 0 ||
          y >= outputHeight
        ) {
          return;
        }

        const index =
          y * outputWidth + x;

        if (background[index]) {
          return;
        }

        if (!isBackgroundPixel(index)) {
          return;
        }

        background[index] = 1;

        queueX[queueEnd] = x;
        queueY[queueEnd] = y;

        queueEnd++;
      }

      /*
        Start from every outside edge.
      */

      for (
        let x = 0;
        x < outputWidth;
        x++
      ) {
        addPixel(x, 0);
        addPixel(
          x,
          outputHeight - 1
        );
      }

      for (
        let y = 0;
        y < outputHeight;
        y++
      ) {
        addPixel(0, y);
        addPixel(
          outputWidth - 1,
          y
        );
      }

      /*
        Flood through connected background pixels.
      */

      while (
        queueStart < queueEnd
      ) {
        const x =
          queueX[queueStart];

        const y =
          queueY[queueStart];

        queueStart++;

        addPixel(
          x - 1,
          y
        );

        addPixel(
          x + 1,
          y
        );

        addPixel(
          x,
          y - 1
        );

        addPixel(
          x,
          y + 1
        );
      }

      /*
        Make only the detected background transparent.
      */

      for (
        let i = 0;
        i < totalPixels;
        i++
      ) {
        if (background[i]) {
        pixels[i * 4 + 3] = 255;
        }
      }

      ctx.putImageData(
        imageData,
        0,
        0
      );

      /*
        PNG is essential here because it preserves
        the transparent background.
      */

      const photo =
        document.createElement("img");

      photo.className =
        "drf-preview-photo";

      photo.src =
        canvas.toDataURL(
          "image/png"
        );

      photo.alt =
        "Engraving preview";

      preview.innerHTML =
        "";

      preview.appendChild(
        photo
      );
    };

    image.src =
      event.target.result;
  };

  reader.readAsDataURL(
    file
  );
}
    /* ==========================================================
       PHOTO PREVIEW
    ========================================================== */

    function updatePhotoPreview(side) {
      const preview =
        getPreview(side);

      if (!preview) return;

      const input =
        getPhotoInput(side);

      if (
        input &&
        input.files &&
        input.files.length
      ) {

        const file =
          input.files[0];

        const renderToken =
          ++photoRenderToken[side];

        const fileName =
          (file.name || "")
            .toLowerCase();

        /*
          Accept normal image MIME types
          plus HEIC extensions.
        */

        const isImage =
          file.type.startsWith("image/") ||
          /\.(jpg|jpeg|png|heic)$/i.test(
            fileName
          );

        if (!isImage) {

          input.value = "";

          photoRenderToken[side]++;

          preview.innerHTML =
            '<span style="opacity:.42;font-size:11px;">Your photo</span>';

          setError(
            "Please upload a JPG, PNG or HEIC image."
          );

          return;
        }

        createEngravingImage(
          file,
          preview,
          side,
          renderToken
        );

      } else {

        preview.innerHTML =
          '<span style="opacity:.42;font-size:11px;">Your photo</span>';
      }

      preview.classList.remove(
        "drf-rotated"
      );
    }

    /* ==========================================================
       PREVIEW
    ========================================================== */

    function updatePreview(side) {
      const type =
        side === "front"
          ? front
          : back;

      if (type === "photo") {

        updatePhotoPreview(
          side
        );

      } else {

        updateTextPreview(
          side
        );
      }
    }

    /* ==========================================================
       SIDE SELECTION
    ========================================================== */

    function setSide(
      side,
      type
    ) {

      /*
        CRITICAL FIX:

        Invalidate any photo processing that is
        still running BEFORE changing the side.
      */

      photoRenderToken[side]++;

      if (side === "front") {
        front = type;
      } else {
        back = type;
      }

      /*
        Photo -> Text:
        create a completely fresh text state.
      */

      if (type === "text") {
        resetTextUI(side);
      }

      const row =
        builder.querySelector(
          '.drf-choice-row[data-side="' +
          side +
          '"]'
        );

      if (row) {
        row
          .querySelectorAll(
            ".drf-choice"
          )
          .forEach(function (button) {

            button.classList.toggle(
              "active",
              button.dataset.type ===
              type
            );

          });
      }

      /*
        Hide all content for this side.
      */

      builder
        .querySelectorAll(
          '[data-content^="' +
          side +
          '-"]'
        )
        .forEach(function (content) {

          content.classList.add(
            "drf-hidden"
          );

        });

      /*
        Show selected content.
      */

      const activeContent =
        builder.querySelector(
          '[data-content="' +
          side +
          "-" +
          type +
          '"]'
        );

      if (activeContent) {
        activeContent.classList.remove(
          "drf-hidden"
        );
      }
      

      const textInput =
        getTextInput(side);

      const photoInput =
        getPhotoInput(side);

      if (textInput) {
        textInput.disabled =
          type !== "text";
      }

      if (photoInput) {
        photoInput.disabled =
          type !== "photo";
      }
      if (type !== "photo" && photoInput) {
  photoInput.value = "";
  photoRenderToken[side]++;
}

      /*
        Close font menus.
      */

      builder
        .querySelectorAll(
          ".drf-font-menu"
        )
        .forEach(function (menu) {

          menu.classList.remove(
            "open"
          );

        });

      /*
        Clear the preview immediately.
      */

      const preview =
        getPreview(side);

      if (preview) {

        preview.innerHTML = "";

        if (type === "text") {

          updateTextPreview(
            side
          );

        } else {

          updatePhotoPreview(
            side
          );
        }
      }

      updateShopifyVariant();
    }

    /* ==========================================================
       TEXT INPUT
    ========================================================== */

    ["front", "back"].forEach(
      function (side) {

        const input =
          getTextInput(side);

        if (!input) return;

        input.addEventListener(
          "input",
          function () {

            const counter =
              input
                .closest(
                  ".drf-text-wrap"
                )
                ?.querySelector(
                  ".drf-counter"
                );

            if (counter) {

              counter.textContent =
                input.value.length +
                "/20";
            }

            /*
              Font menu options still show
              the customer's text.
            */

            builder
              .querySelectorAll(
                '[data-font-menu="' +
                side +
                '"] .drf-font-option > span'
              )
              .forEach(
                function (preview) {

                  preview.textContent =
                    input.value.trim() ||
                    "Your text";
                }
              );

            /*
              CLOSED selector stays:
              Aa — Font Name

              Customer text is NOT placed
              beside the font name.
            */

            const trigger =
              builder.querySelector(
                '[data-font-trigger="' +
                side +
                '"]'
              );

            if (trigger) {

              const previewText =
                trigger.querySelector(
                  ".drf-font-preview-text"
                );

              if (previewText) {

                previewText.textContent =
                  "Aa";
              }
            }

            updatePreview(side);

            setError("");
          }
        );
      }
    );

    /* ==========================================================
       FONT TRIGGERS
    ========================================================== */

    builder
      .querySelectorAll(
        ".drf-font-trigger"
      )
      .forEach(
        function (trigger) {

          trigger.addEventListener(
            "click",
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              const side =
                trigger.dataset.fontTrigger;

              const menu =
                builder.querySelector(
                  '[data-font-menu="' +
                  side +
                  '"]'
                );

              builder
                .querySelectorAll(
                  ".drf-font-menu"
                )
                .forEach(
                  function (other) {

                    if (other !== menu) {
                      other.classList.remove(
                        "open"
                      );
                    }
                  }
                );

              if (menu) {
                menu.classList.toggle(
                  "open"
                );
              }
            }
          );
        }
      );

    /* ==========================================================
       FONT OPTIONS
    ========================================================== */

    builder
      .querySelectorAll(
        ".drf-font-option"
      )
      .forEach(
        function (button) {

          button.addEventListener(
            "click",
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              const menu =
                button.closest(
                  ".drf-font-menu"
                );

              if (!menu) return;

              const side =
                menu.dataset.fontMenu;

              const font =
                button.dataset.font;

              menu
                .querySelectorAll(
                  ".drf-font-option"
                )
                .forEach(
                  function (item) {

                    item.classList.remove(
                      "active"
                    );
                  }
                );

              button.classList.add(
                "active"
              );

              if (side === "front") {
                frontFont = font;
              } else {
                backFont = font;
              }

              const hidden =
                builder.querySelector(
                  side === "front"
                    ? "#drf-front-font"
                    : "#drf-back-font"
                );

              if (hidden) {
                hidden.value = font;
              }

              const trigger =
                builder.querySelector(
                  '[data-font-trigger="' +
                  side +
                  '"]'
                );

              if (trigger) {

                const previewText =
                  trigger.querySelector(
                    ".drf-font-preview-text"
                  );

                const name =
                  trigger.querySelector(
                    ".drf-selected-font-name"
                  );

                /*
                  CLOSED selector:
                  Always show Aa, never the
                  customer's typed text.
                */

                if (previewText) {

                  previewText.className =
                    "drf-font-preview-text " +
                    getFontClass(font);

                  previewText.textContent =
                    "Aa";
                }

                if (name) {
                  name.textContent =
                    font;
                }
              }

              menu.classList.remove(
                "open"
              );

              updatePreview(side);
            }
          );
        }
      );

    /* ==========================================================
       CLOSE FONT MENUS
    ========================================================== */

    document.addEventListener(
      "click",
      function () {

        builder
          .querySelectorAll(
            ".drf-font-menu"
          )
          .forEach(
            function (menu) {

              menu.classList.remove(
                "open"
              );

            }
          );
      }
    );

    /* ==========================================================
       DIRECTION
    ========================================================== */

    builder
      .querySelectorAll(
        ".drf-direction"
      )
      .forEach(
        function (button) {

          button.addEventListener(
            "click",
            function (event) {

              event.preventDefault();

              const row =
                button.closest(
                  ".drf-direction-row"
                );

              if (!row) return;

              const side =
                row.dataset.directionSide;

              const direction =
                button.dataset.direction;

              row
                .querySelectorAll(
                  ".drf-direction"
                )
                .forEach(
                  function (item) {

                    item.classList.remove(
                      "active"
                    );
                  }
                );

              button.classList.add(
                "active"
              );

              if (side === "front") {

                frontDirection =
                  direction === "rotated"
                    ? "Rotated"
                    : "Horizontal";

                const hidden =
                  builder.querySelector(
                    "#drf-front-direction"
                  );

                if (hidden) {
                  hidden.value =
                    frontDirection;
                }

              } else {

                backDirection =
                  direction === "rotated"
                    ? "Rotated"
                    : "Horizontal";

                const hidden =
                  builder.querySelector(
                    "#drf-back-direction"
                  );

                if (hidden) {
                  hidden.value =
                    backDirection;
                }
              }

              updatePreview(side);
            }
          );
        }
      );

    /* ==========================================================
       PHOTO UPLOAD
    ========================================================== */

    ["front", "back"].forEach(
      function (side) {

        const photoInput =
          getPhotoInput(side);

        if (!photoInput) return;

        photoInput.addEventListener(
          "change",
          function () {

            const file =
              photoInput.files[0];

            if (!file) {

              updatePreview(side);

              return;
            }

            if (
              file.size >
              10 * 1024 * 1024
            ) {

              photoInput.value = "";

              photoRenderToken[side]++;

              setError(
                "Please choose a photo smaller than 10 MB."
              );

              updatePreview(side);

              return;
            }

            const fileName =
              (file.name || "")
                .toLowerCase();

            const isImage =
              file.type.startsWith(
                "image/"
              ) ||
              /\.(jpg|jpeg|png|heic)$/i.test(
                fileName
              );

            if (!isImage) {

              photoInput.value = "";

              photoRenderToken[side]++;

              setError(
                "Please upload a JPG, PNG or HEIC image."
              );

              updatePreview(side);

              return;
            }

            setError("");

            updatePreview(side);
          }
        );
      }
    );

    /* ==========================================================
       TEXT / PHOTO BUTTONS
    ========================================================== */

    builder
      .querySelectorAll(
        ".drf-choice"
      )
      .forEach(
        function (button) {

          button.addEventListener(
            "click",
            function (event) {

              event.preventDefault();

              const row =
                button.closest(
                  ".drf-choice-row"
                );

              if (!row) return;

              setSide(
                row.dataset.side,
                button.dataset.type
              );
            }
          );
        }
      );

    /* ==========================================================
       SUBMIT VALIDATION
    ========================================================== */

    if (form) {

      form.addEventListener(
        "submit",
        function (event) {

          setError("");

          const frontText =
            getTextInput("front");

          const backText =
            getTextInput("back");

          const frontPhoto =
            getPhotoInput("front");

          const backPhoto =
            getPhotoInput("back");

          if (
            front === "text" &&
            (
              !frontText ||
              !frontText.value.trim()
            )
          ) {

            event.preventDefault();

            setError(
              "Please enter the text you want engraved on the front."
            );

            return;
          }

          if (
            back === "text" &&
            (
              !backText ||
              !backText.value.trim()
            )
          ) {

            event.preventDefault();

            setError(
              "Please enter the text you want engraved on the back."
            );

            return;
          }

          if (
            front === "photo" &&
            (
              !frontPhoto ||
              !frontPhoto.files.length
            )
          ) {

            event.preventDefault();

            setError(
              "Please upload one photo for the front."
            );

            return;
          }

          if (
            back === "photo" &&
            (
              !backPhoto ||
              !backPhoto.files.length
            )
          ) {

            event.preventDefault();

            setError(
              "Please upload one photo for the back."
            );

            return;
          }

          if (
            front === "none" &&
            back === "none"
          ) {

            event.preventDefault();

            setError(
              "Please customize at least one side of your keychain."
            );

            return;
          }

          const selected =
            variants[currentKey()];

          if (!selected) {

            event.preventDefault();

            setError(
              "Please select your customization."
            );

            return;
          }

          if (variantInput) {
            variantInput.value =
              selected.id;
          }
        }
      );
    }
/* ==========================================================
   CUSTOM PURCHASE CONTROLS
========================================================== */

const customPrice =
  builder.querySelector("#drf-custom-price");

const customQuantityValue =
  builder.querySelector("#drf-quantity-value");

const customQuantityMinus =
  builder.querySelector("#drf-quantity-minus");

const customQuantityPlus =
  builder.querySelector("#drf-quantity-plus");

const customAddToCart =
  builder.querySelector("#drf-custom-add-to-cart");

let customQuantity = 1;

function getNativeQuantityInput() {
  if (!form) return null;

  return (
    form.querySelector('input[name="quantity"]') ||
    form.querySelector(".quantity__input")
  );
}

function updateCustomPurchaseUI() {
  const selected =
    variants[currentKey()];

  if (!selected) return;
    const isAvailable = selected.available !== false;

      if (customAddToCart) {
    customAddToCart.disabled = !isAvailable;
    customAddToCart.textContent =
      isAvailable ? "ADD TO CART" : "SOLD OUT";
  }

  /* PRICE */

  if (customPrice) {
    customPrice.textContent =
      "€" + selected.price.toFixed(2);
  }

  /* QUANTITY DISPLAY */

  if (customQuantityValue) {
    customQuantityValue.textContent =
      customQuantity;
  }

  /* SHOPIFY NATIVE QUANTITY */

  const nativeQuantity =
    getNativeQuantityInput();

  if (nativeQuantity) {
    nativeQuantity.value =
      customQuantity;

    nativeQuantity.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );
  }
}


/* MINUS */

if (customQuantityMinus) {
  customQuantityMinus.addEventListener(
    "click",
    function () {

      if (customQuantity > 1) {
        customQuantity--;

        updateCustomPurchaseUI();
      }

    }
  );
}


/* PLUS */

if (customQuantityPlus) {
  customQuantityPlus.addEventListener(
    "click",
    function () {

      customQuantity++;

      updateCustomPurchaseUI();

    }
  );
}


/* ADD TO CART */

if (customAddToCart) {
  customAddToCart.addEventListener("click", function (event) {
    event.preventDefault();

    setError("");

    if (!form) {
      setError("Unable to add this item to the cart.");
      return;
    }

    const selected = variants[currentKey()];

    if (!selected) {
      setError("Please select your customization.");
      return;
    }

    const frontText = getTextInput("front");
    const backText = getTextInput("back");
    const frontPhoto = getPhotoInput("front");
    const backPhoto = getPhotoInput("back");

    if (front === "text" && (!frontText || !frontText.value.trim())) {
      setError("Please enter the text you want engraved on the front.");
      return;
    }

    if (back === "text" && (!backText || !backText.value.trim())) {
      setError("Please enter the text you want engraved on the back.");
      return;
    }

    if (front === "photo" && (!frontPhoto || !frontPhoto.files.length)) {
      setError("Please upload one photo for the front.");
      return;
    }

    if (back === "photo" && (!backPhoto || !backPhoto.files.length)) {
      setError("Please upload one photo for the back.");
      return;
    }

    if (front === "none" && back === "none") {
      setError("Please customize at least one side of your keychain.");
      return;
    }

    if (variantInput) {
      variantInput.value = selected.id;
      variantInput.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }

    updateCustomPurchaseUI();

    const nativeSubmitButton = form.querySelector(
      'button[type="submit"]'
    );

    if (!nativeSubmitButton) {
      setError("Unable to add this item to the cart.");
      return;
    }

    /* CUSTOM BUTTON LOADING STATE */
customAddToCart.disabled = true;
customAddToCart.textContent = "JUST A MOMENT...";

/* Watch Shopify's native submit button */
const loadingObserver = new MutationObserver(function () {
  const stillLoading =
    nativeSubmitButton.classList.contains("loading") ||
    nativeSubmitButton.getAttribute("aria-disabled") === "true";

  if (!stillLoading) {
    customAddToCart.disabled = false;
    customAddToCart.textContent = "ADD TO CART";
    loadingObserver.disconnect();
  }
});

loadingObserver.observe(nativeSubmitButton, {
  attributes: true,
  attributeFilter: ["class", "aria-disabled"]
});

/* Let Dawn handle the actual add-to-cart */
nativeSubmitButton.click();
  });
}
    /* ==========================================================
       INITIAL STATE
    ========================================================== */

    setSide(
      "front",
      "text"
    );

    setSide(
      "back",
      "text"
    );

    updatePreview("front");
updatePreview("back");

updateShopifyVariant();
loadLiveVariantPrices();
  }

  /* ==========================================================
     INITIAL LOAD
  ========================================================== */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initDRFCustomKeychain
    );

  } else {

    initDRFCustomKeychain();
  }

  /* ==========================================================
     SHOPIFY THEME EDITOR
  ========================================================== */

  document.addEventListener(
    "shopify:section:load",
    function () {
      initDRFCustomKeychain();
    }
  );

})();